export default __webpack_public_path__ + "static/03-b-underline-no-user-07315e043e45bd2f164f884a9ef2f4eb.svg";